<template>
    <v-container class="p-relative">
        <v-row>
            <v-col cols="12" md="12" class="py-0">
                <RegistryHeader
                    :title="getNewsletterRegistry.name"
                    :avatarData="getNewsletterRegistry.currentMenager"
                    @clearSearch="clearTable"
                />
                <Table
                      :title="getNewsletterRegistry.name"
                    :items="getNewsletterTable.items"
                    :headers="headers"
                    :length="getNewsletterTable.pages"
                    :page="getNewsletterTable.page"
                    @search="setSearch"
                    @clear-table="clearTable"
                    @search-fields="setSearchFields"
                    @change-page="setPage"
                    @sort="setSort"
                    :defaultFields="getNewsletterSearchFields.searchFields"
                    :loading="getNewsletterTable.loading"
                >
                    <Columns slot="columns" :items="getNewsletterTable.items" />
                </Table>
                <Modal
                    :title="$t('newsletter:adding')"
                    :open="open"
                    :height="'545'"
                    v-on:close="closeModal"
                >
                    <AEContent slot="AEContent" />
                    <Buttons
                        :action="'create'"
                        slot="buttons"
                        @closeModal="open = false"
                    />
                </Modal>
                <div class="d-flex justify-end buttons--action">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                data-cy="addEntry"
                                fab
                                dark
                                v-on="on"
                                small
                                v-if="add()"
                                @click="addNewsletter()"
                                class="buttons--add margin--1"
                            >
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('newsletter:addNewsletter') }}</span>
                    </v-tooltip>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import store from './../../../store/index'
import Columns from './../../../components/Registries/Newsletter/Table/Columns'
import AEContent from './../../../components/Registries/Newsletter/Modal/Content'
import Buttons from './../../../components/Registries/Newsletter/Modal/Buttons'
export default {
    data() {
        return {
            open: false,
            headers: [
                {
                    text: this.$t('newsletter:index'),
                    value: 'index',
                    width: '10%',
                    showSearch: true,
                },
                {
                    text: this.$t('newsletter:createdAt'),
                    value: 'createdAt',
                    width: '10%',
                },
                {
                    text: this.$t('newsletter:email'),
                    value: 'email',
                    width: 'auto',
                    showSearch: true,
                },
                {
                    text: this.$t('newsletter:source'),
                    value: 'newsletterKind',
                    width: '15%',
                    showSearch: true,
                },
                {
                    text: this.$t('newsletter:status'),
                    value: 'status.name',
                    width: '6%',
                    showSearch: true,
                },
                {
                    text: '',
                    value: 'arrow',
                    align: 'right',
                    width: '9%',
                    sortable: false,
                },
            ],
        }
    },
    components: {
        Columns,
        AEContent,
        Buttons,
    },
    computed: {
        ...mapGetters([
            'getNewsletterRegistry',
            'getNewsletterTable',
            'getNewsletterSearchFields',
            'getSearch',
        ]),
    },
    methods: {
        ...mapActions(['fetchNewsletterTable']),
        ...mapMutations([
            'clearNewsletterModal',
            'clearNewsletterErrors',
            'setNewsletterTable',
            'clearNewsletterTable',
            'setNewsletterSearch',
        ]),
        add() {
            return this.checkPermissions('CREATE')
        },
        closeModal() {
            // this.clearCarsErrors()
            this.open = false
        },
        addNewsletter() {
            this.clearNewsletterModal()
            this.open = true
            this.setNewsletterTable()
        },
        setSearchFields(searchFields) {
            this.setNewsletterSearch(searchFields)
        },
        setSearch(search) {
            this.setNewsletterTable({ search, page: 1 })
            this.fetchNewsletterTable()
        },
        setPage(page) {
            this.clearNewsletterTable({ page })
            this.fetchNewsletterTable()
        },
        setSort(sort) {
            this.clearNewsletterTable({ sort })
            this.fetchNewsletterTable()
        },
        clearTable() {
            this.getSearch.text = ''
            this.clearNewsletterTable()
            this.fetchNewsletterTable()
        },
    },
    beforeRouteEnter(to, from, next) {
        if (from.matched[1] && from.matched[1].path !== '/newsletter/:id')
            store.commit('clearNewsletterTable')
        store.dispatch('fetchNewsletterTable').then(() => next())
    },
}
</script>
